<template>
  <div :class="classInput">
    <div class="form-group" :class="{'is-invalid': isInvalid, 'input-group-disabled': isDisabled}">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <input
        :value="value"
        :type="type"
        class="form-control"
        :class="{'is-invalid': isInvalid}"
        :disabled="isDisabled"
        @blur="() => validate()"
        @input="inputHandle($event.target.value)"
        :ref="'refinput'+id"
      >
      <div
        v-if="isInvalid"
        class="invalid-feedback"
      >
        <span v-if="isInvalid">Campo obrigatório.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text',
      validator (value) {
        return ['text', 'email', 'password'].includes(value)
      }
    },
    typeInput: {
      type: String
    },
    value: {
      type: String
    },
    classInput: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    forceShowError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false,
      hasTouched: false
    }
  },
  watch: {
    forceShowError (newVal) {
      if (newVal) {
        this.validate()
      }
    }
  },
  methods: {
    inputHandle (value) {
      this.hasTouched = true

      // Se o campo estava com erro e o usuário está digitando, limpar o erro imediatamente
      if (this.isInvalid && value && value !== '') {
        this.isInvalid = false
      }

      this.$emit('input', value)
    },
    validate () {
      // Mostra erro se: campo foi tocado OU forçado a mostrar erro
      const shouldValidate = this.hasTouched || this.forceShowError
      this.isInvalid = shouldValidate && this.isRequired && (!this.value || this.value === '')
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    },
    clean () {
      this.isInvalid = false
      this.hasTouched = false
    }
  }
}
</script>
